import React, { FC } from "react";
import { faPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const PaperPlane: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faPaperPlane} {...props} />
);
